export function sortListByKey(list, key, info) {

  if (info?.sortType) {
    return list;
  }

  const isValidList = list || [];
  const isDescending = info?.sortDirection === 'desc';

  const getValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc?.[part], obj) || '';
  };

  return [...isValidList].sort((a, b) => {
    let valueA, valueB;

    if (key === 'fullName') {
      const firstA = a.firstName || '';
      const lastA = a.lastName || '';
      const firstB = b.firstName || '';
      const lastB = b.lastName || '';
      valueA = `${firstA} ${lastA}`.toLowerCase();
      valueB = `${firstB} ${lastB}`.toLowerCase();
    } else {
      valueA = getValue(a, key).toString().toLowerCase();
      valueB = getValue(b, key).toString().toLowerCase();
    }

    return isDescending
      ? valueB.localeCompare(valueA)
      : valueA.localeCompare(valueB);
  });
}